import { DSAlert, DSButton, DSModal } from '@vr/ds-react'

const ModalError = ({
  children,
  isOpen,
  onClose = () => {},
  title
}: {
  children?: React.ReactNode
  isOpen: boolean
  onClose?: () => void
  title?: string
}) => {
  return (
    <DSModal config={{ show: isOpen, onClose }}>
      <DSModal.Body>
        <DSAlert type='error' hiddenBtnClose title={title || 'Erro!'}>
          {children}
        </DSAlert>
      </DSModal.Body>
      <DSModal.Footer css={{ display: 'flex', justifyContent: 'center' }}>
        <DSButton onClick={onClose} variant='secondary'>
          Fechar
        </DSButton>
      </DSModal.Footer>
    </DSModal>
  )
}

export default ModalError
